export default "__VITE_ASSET__G2F2gBoH__"